import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import { tKey } from 'ember-intl';

const DEMAND_LEVEL_TRANSLATION_MAP = {
  1: tKey('market_insight.rate_level.level1'),
  2: 'market_insight.rate_level.level2',
  3: 'market_insight.rate_level.level3',
  4: tKey('market_insight.rate_level.level4'),
  5: 'market_insight.rate_level.level5',
  6: tKey('market_insight.rate_level.level6'),
};

const DEMAND_LEVEL_COLOR_CLASS_MAP = {
  1: 'demand-main-bg-color--level-1',
  2: 'demand-main-bg-color--level-2',
  3: 'demand-main-bg-color--level-3',
  4: 'demand-main-bg-color--level-4',
  5: 'demand-main-bg-color--level-5',
  6: 'demand-main-bg-color--level-6',
};

interface HotelOverviewDashboardFeedFeedEntryDemandLevelEntrySignature {
  Args: {
    value: unknown;
  };
}

export default class HotelOverviewDashboardFeedFeedEntryDemandLevelEntry extends Component<HotelOverviewDashboardFeedFeedEntryDemandLevelEntrySignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get currentDemandLevel() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.demandLevels[1];
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get currentDemandLevelColorClass() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return DEMAND_LEVEL_COLOR_CLASS_MAP[this.currentDemandLevel];
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get currentDemandLevelLabel() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
    return this.intl.t(DEMAND_LEVEL_TRANSLATION_MAP[this.currentDemandLevel]);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get demandLevels() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return this.args.value.split('|');
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get iconColor() {
    return this.currentDemandLevel > this.prevDemandLevel
      ? 'success'
      : 'critical';
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get iconName() {
    return this.currentDemandLevel > this.prevDemandLevel
      ? 'arrow-up'
      : 'arrow-down';
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get prevDemandLevel() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.demandLevels[0];
  }

  <template>
    <span class="flex flex-row items-center">
      <div
        class="demand-change-indicator--normal
          {{this.currentDemandLevelColorClass}}
          mr-100"
      >
      </div>
      <span>{{this.currentDemandLevelLabel}}</span>
      <PrismIcon
        @name={{this.iconName}}
        @size="small"
        {{! @glint-expect-error: Incorrect type }}
        color={{this.iconColor}}
      />
    </span>
  </template>
}
